import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { StyledLoadingButton } from "../../../customComponents/styled/styledButtons";
import { StyledTextField } from "../../../customComponents/styled/styledInputs";
import { useUpdateSessionMutation } from "./sessionApiSlice";
import { format, parseISO } from "date-fns";
import toast from "../../../../helpers/toast";

const validationSchema = yup.object({
  name: yup.string().required("Session name is required"),
  starts_at: yup.string().required("Required"),
  ends_at: yup.string().required("Required"),
});

function EditSessionForm({ sessionToEdit, setSessionToEdit }) {
  const [updateSession, { isLoading }] = useUpdateSessionMutation();

  const formik = useFormik({
    initialValues: {
      id: sessionToEdit.id,
      name: sessionToEdit.name,
      starts_at: format(parseISO(sessionToEdit.starts_at), "yyyy-MM-dd"),
      ends_at: format(parseISO(sessionToEdit.ends_at), "yyyy-MM-dd"),
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const response = await updateSession(values).unwrap();
        if (response) {
          toast.success("Session updated Successfully");
          formik.resetForm();
          setSessionToEdit(null);
        }
      } catch (error) {
        toast.error(error?.message || "Something went wrong");
      }
    },
  });
  return (
    <div>
      <Box className="paperHeader">
        <Typography variant="formHeading">Update Session</Typography>
      </Box>
      <Box className="paperBody">
        <form onSubmit={formik.handleSubmit}>
          <Grid container columnSpacing={1} rowSpacing={2}>
            <Grid item xs={12}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">Session Name</Typography>
                <StyledTextField
                  autoFocus
                  variant="outlined"
                  id="name"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                />
                <FormHelperText variant="error">
                  {formik.touched.name && formik.errors.name}
                </FormHelperText>
              </FormControl>
            </Grid>

            {/* End of first row */}

            <Grid item xs={12} lg={6}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">Start date</Typography>
                <StyledTextField
                  type="date"
                  variant="outlined"
                  id="starts_at"
                  name="starts_at"
                  value={formik.values.starts_at}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.starts_at && Boolean(formik.errors.starts_at)
                  }
                />
                <FormHelperText variant="error">
                  {formik.touched.starts_at && formik.errors.starts_at}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">End Date</Typography>
                <StyledTextField
                  type="date"
                  variant="outlined"
                  id="ends_at"
                  name="ends_at"
                  value={formik.values.ends_at}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.ends_at && Boolean(formik.errors.ends_at)
                  }
                />
                <FormHelperText variant="error">
                  {formik.touched.ends_at && formik.errors.ends_at}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} textAlign={"right"}>
              <StyledLoadingButton loading={isLoading} type="submit">
                update
              </StyledLoadingButton>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
}

export default EditSessionForm;
